module.exports = __webpack_public_path__ + "img/humedad_green.dcc724f1.svg";